import React from 'react';
import Loader from '../../../common/loader/Loader';

const TierFeatureLoader = ({ tierFeatureLength }) => {
	return (
		<>
			{Array.apply(null, Array(tierFeatureLength)).map((item, number) => {
				return (
					<div
						className="tier-feature__value tier-feature__value--loader"
						key={`tier-feature-${number}`}
					>
						<Loader />
					</div>
				);
			})}
		</>
	);
};

export default TierFeatureLoader;
